import { render, staticRenderFns } from "./NuevaEvolucion.vue?vue&type=template&id=b77806b2&scoped=true"
import script from "./NuevaEvolucion.vue?vue&type=script&lang=js"
export * from "./NuevaEvolucion.vue?vue&type=script&lang=js"
import style0 from "./NuevaEvolucion.vue?vue&type=style&index=0&id=b77806b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77806b2",
  null
  
)

export default component.exports